const html = require("choo/html");

module.exports = function(state) {
  const fileInfo = state.fileInfo;

  return html`
    <div
      class="h-full w-full flex flex-col items-center justify-center bg-white py-8 max-w-md mx-auto dark:bg-grey-90"
    >
      <h1 class="text-3xl font-bold mb-4">
        ${state.translate("downloadTitle")}
      </h1>

      <div class="w-full text-left text-xl leading-normal dark:text-grey-40">
        <p>${state.translate("uploadedBy")}</p>
        <ul class="list-disc ml-4">
          <p>${state.fileInfo}</p>
          <li>${state.fileInfo.uploadedBy}</li>
          <li>${state.fileInfo.uploadedSSN}</li>
        </ul>
        <p>${state.translate("uploadedDiscl")}</p>
      </div>

      <p
        class="w-full mb-4 text-center text-grey-80 dark:text-grey-40 leading-normal"
      >
        ${state.translate("downloadDescription")}
      </p>

      <!-- <p
         class="w-full mb-4 text-center text-grey-80 dark:text-grey-40 leading-normal"
       >
         ${state.translate("redirectIsland")}
       </p> -->

      <form
        class="flex flex-row flex-no-wrap justify-center w-full md:w-4/5"
        onsubmit="${checkSSN}"
        data-no-csrf
      >
        <input
          type="submit"
          id="ssn-btn"
          class="btn rounded-lg"
          value="Sim Authenticate"
          title="Sim Authenticate"
        />
      </form>
    </div>
  `;

  function checkSSN(event) {
    event.stopPropagation();
    event.preventDefault();
    document.getElementById("ssn-btn").disabled = true;

    sessionStorage.setItem("key", fileInfo.secretKey);
    sessionStorage.setItem("nonce", fileInfo.nonce);

    window.location.replace("/mobileid/" + fileInfo.id);
  }
};
